"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = require("lodash");
var _reactIntl = require("react-intl");
var _DraftEditorField = _interopRequireDefault(require("../../../form/DraftEditorField"));
var _ExpandableContainer = _interopRequireDefault(require("../../../ExpandableContainer"));
var _HoursOfOperationV = _interopRequireDefault(require("../../../hours/HoursOfOperationV2"));
var _ContactInformation = _interopRequireDefault(require("../../../contact/ContactInformation"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ProviderDescription = function ProviderDescription(_ref) {
  var className = _ref.className,
    provider = _ref.provider,
    isInNetworkGroup = _ref.isInNetworkGroup,
    showMore = _ref.showMore,
    intlProvider = _ref.intlProvider;
  var description = (0, _lodash.get)(provider, 'description');
  var email_addresses = provider.email_addresses,
    phone_numbers = provider.phone_numbers,
    primary_contact_name = provider.primary_contact_name,
    website_url = provider.website_url;
  var showContactInfo = !(0, _lodash.isEmpty)(email_addresses) || !(0, _lodash.isEmpty)(phone_numbers) || !(0, _lodash.isEmpty)(primary_contact_name) || !(0, _lodash.isEmpty)(website_url);
  var headerText = !(0, _lodash.isEmpty)(intlProvider) ? /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "Z+Mo8M",
    description: "org-contact-header",
    defaultMessage: "Organization Contact Information"
  }, function (txt) {
    return /*#__PURE__*/_react["default"].createElement("div", null, txt);
  }) : 'Organization Contact Information';
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('provider-description', className)
  }, /*#__PURE__*/_react["default"].createElement(_ExpandableContainer["default"], {
    controlled: true,
    hideToggle: true,
    id: "detail-description-expandable",
    isOpen: showMore,
    showGradient: false,
    useFirstChildHeight: true
  }, description && /*#__PURE__*/_react["default"].createElement("div", {
    className: "provider-description__text"
  }, /*#__PURE__*/_react["default"].createElement(_DraftEditorField["default"], {
    hideLabel: true,
    id: "description-".concat((0, _lodash.get)(provider, 'id')),
    label: "Description",
    readOnly: true,
    value: description
  })), showContactInfo && /*#__PURE__*/_react["default"].createElement(_ContactInformation["default"], {
    email_addresses: email_addresses,
    headerText: headerText,
    isInNetworkGroup: isInNetworkGroup,
    phone_numbers: phone_numbers,
    primary_contact_name: primary_contact_name,
    showMore: showMore,
    website_url: website_url
  }), !(0, _lodash.isEmpty)(provider.hours) && /*#__PURE__*/_react["default"].createElement(_HoursOfOperationV["default"], {
    className: "ui-provider-card__hours",
    hours: provider.hours,
    isInNetworkGroup: isInNetworkGroup,
    showAll: showMore,
    showHoursIcon: true,
    showMore: showMore,
    showToggle: showMore,
    intlProvider: intlProvider
  })));
};
ProviderDescription.propTypes = {
  className: _propTypes["default"].string,
  showMore: _propTypes["default"].bool,
  provider: _propTypes["default"].object.isRequired,
  isInNetworkGroup: _propTypes["default"].bool,
  intlProvider: _propTypes["default"].object
};
ProviderDescription.defaultProps = {
  className: '',
  isInNetworkGroup: true,
  showMore: false,
  intlProvider: {}
};
var _default = exports["default"] = ProviderDescription;